/**
 * Anapara çevrimi özetinin panelde nasıl okunacağı.
 *
 * Aynı özet iki ekranda birden çizilir — üye profili ve çekim talebinin detay
 * paneli — ve ikisi aynı şeyi söylemelidir: yönetici profilde "çevrilmiş"
 * yazan bir üyenin çekimine bakarken başka bir cümle görmemelidir. Metin ve
 * renk seçimi bu yüzden bileşenlerde değil burada durur.
 *
 * Veri `/admin/users/{id}/turnover` (ve profil ucunun `principal_turnover`
 * alanı) ile gelir; eşiğin kendisi backend'dedir
 * (backend/services/principal_turnover.py `TURNOVER_MULTIPLIER`).
 */

// Rozetin panel sınıfı. Profil kartı ile çekim detay paneli aynı rengi
// göstermelidir; eşleme bu yüzden burada durur.
export const TURNOVER_BADGE = {
  green: 'badge-green',
  red: 'badge-red',
  gray: 'badge-gray',
};

const percent = (ratio) => `%${Math.round(Number(ratio || 0) * 100)}`;

export const turnoverView = (summary) => {
  // Onaylı yatırımı olmayan üyede ölçülecek anapara yoktur; "çevrilmedi"
  // demek yanlış olurdu — çevrilecek bir şey yok.
  if (!summary || !summary.has_deposit) {
    return {
      state: 'none',
      label: 'Onaylı yatırım yok',
      tone: 'gray',
      detail: 'Üyenin onaylanmış yatırımı olmadığı için ölçülecek anapara yok.',
    };
  }

  if (summary.completed) {
    return {
      state: 'completed',
      label: 'Anapara çevrilmiş',
      tone: 'green',
      detail: summary.ratio === null
        ? 'Son yatırım tutarı sıfır; çevrim aranmıyor.'
        : `Son yatırımın ${percent(summary.ratio)} kadarı oynanmış.`,
    };
  }

  return {
    state: 'pending',
    label: 'Anapara çevrilmemiş',
    tone: 'red',
    detail: `Son yatırımın ${percent(summary.ratio)} kadarı oynanmış; `
      + 'çevrim için eksik tutar aşağıda.',
  };
};

export default turnoverView;
